import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { Grid, Typography, useMediaQuery, useTheme } from '@mui/material'
import ChevronRightIcon from '@mui/icons-material/ChevronRightRounded'

import Alerts from '@hapana/shared/web/components/shared/alerts/alert.component'
import { ALERT_TYPES, ICON_SIZE } from '@hapana/shared/web/components/shared/alerts/alert.constant'

import { styles } from './view-alerts.styles'
import { MOBILE_MAX_ALERTS_ICONS } from './view-alerts.constants'

const ViewAllAlerts = ({ alerts, onClick, hasTextLink }) => {
  const { t } = useTranslation()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  return (
    <Grid sx={styles.container} component="button" onClick={onClick}>
      <Alerts
        iconList={alerts}
        displayAvatarGroup
        iconSize={ICON_SIZE.SMALL}
        hoverEffect
        numberOfIcons={isMobile ? MOBILE_MAX_ALERTS_ICONS : alerts.length}
      />
      {hasTextLink && (
        <>
          <Typography typography="header4" color="gray.80" sx={styles.viewAllAlerts}>
            {t('checkIn:viewAllAlerts')}
          </Typography>
          <ChevronRightIcon sx={styles.icon} fontSize="small" />
        </>
      )}
    </Grid>
  )
}

ViewAllAlerts.propTypes = {
  alerts: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.oneOf(Object.values(ALERT_TYPES)),
    })
  ).isRequired,
  onClick: PropTypes.func,
  hasTextLink: PropTypes.bool,
}

ViewAllAlerts.defaultProps = {
  onClick: () => {},
}

export default ViewAllAlerts
